<template>
  <el-container id="layout-container" class="app-wrapper">
    <el-header class="layout-nav" :style="{'background-color': this.$store.getters.theme}">
      <NavMenu/>
    </el-header>
    <el-container class="body-container">
      <el-main style="padding: 0;">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import {NavMenu} from './layout.js'
import adapter from './adapter'

export default {
  name: 'LayoutSite',
  components: {NavMenu},
  data() {
    return {}
  },
  mixins: [adapter],
}
</script>

<style lang="less" scoped>

@import '../assets/css/variables.less';

.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;

  .layout-nav {
    width: 100%;
    height: @topNavHeight !important;
    padding: 0 0 1px 0;
    margin: 0;
    //background: #FFFFFF;
    //border-bottom: 1px solid #efefef;
    box-sizing: border-box;
  }

  .body-container {
    height: calc(100% - @topNavHeight);
    background-color: #FFFFFF;
  }
}

</style>
